import type { User } from 'firebase/auth'
import { createContext } from 'react'

export interface AuthContextType {
  user: User | null
  loading: boolean
  isAuthenticated: boolean
  retriggerAuth: () => Promise<void>
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
